import type { AccessibleError } from "./types.js";

export interface ErrorBannerProps {
  readonly error: AccessibleError | null;
  readonly onDismiss?: () => void;
  readonly onRetry?: () => void;
  readonly title?: string;
  readonly testId?: string;
}

export function ErrorBanner(props: ErrorBannerProps) {
  if (!props.error) {
    return null;
  }
  const title = props.title ?? "Операция не выполнена";
  const showRetry = Boolean(props.onRetry) && props.error.retryable !== false;
  return (
    <div
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
      data-testid={props.testId ?? "error-banner"}
      id={props.error.id}
      className="pwz-sheet pwz-mark pwz-mark--danger relative z-[60] flex items-start justify-between gap-3 py-3 pr-3 pl-4"
    >
      <div className="min-w-0 flex-1">
        <p className="pwz-eyebrow text-danger-500">{title}</p>
        <p className="mt-1 break-words text-sm text-ink-900">{props.error.message}</p>
        <p className="pwz-readout mt-1.5 text-xs text-ink-600">
          {props.error.code}
          {props.error.correlationId ? ` · ${props.error.correlationId}` : ""}
        </p>
        {showRetry ? (
          <button
            type="button"
            className="pwz-btn pwz-btn-secondary mt-3"
            data-testid="error-retry"
            onClick={props.onRetry}
          >
            Повторить
          </button>
        ) : null}
      </div>
      {props.onDismiss ? (
        <button
          type="button"
          className="pwz-btn pwz-btn-ghost shrink-0"
          onClick={props.onDismiss}
          aria-label="Закрыть уведомление"
          data-testid="error-dismiss"
        >
          Закрыть
        </button>
      ) : null}
    </div>
  );
}
